export default __webpack_public_path__ + "static/media/Facebook.3766e104.svg";